import React, { Component } from "react"
import PropTypes from "prop-types"

import styles from "./Toggle.css"

class PanelToggle extends Component {
  static propTypes = {
    header: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
  }
  static defaultProps = {
    className: "",
  }
  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    const { open } = this.state
    this.setState({
      open: !open,
    })
  }

  render() {
    const { header, children, className } = this.props
    const { open } = this.state
    /* eslint-disable */
    return (
      <div className={[className].join(" ")}>
        <section>
          <div className={styles.header} onClick={this.toggle}>
            {header}
            <div className={styles.toggle}>
              <i className={open ? "icon-arrow-up" : "icon-arrow-down"} />
            </div>
          </div>
          <div className={[styles.container, open ? styles.isOpen : ""].join(" ")}>
            <div className={styles.content}>
              {children}
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default PanelToggle



// WEBPACK FOOTER //
// ./src/shared/components/Toggle/Toggle.js